import { type TypedDocumentNode, gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useMatchContainer } from '@sorare/core/src/hooks/ui/useMatchContainer';

import { CardPackGroup } from '../BuyPacks/CardPackGroup';
import { commonPacksContainerQuery } from '../CommonPacksPage/utils';
import type { CardPacksGroups_cardPackGroup } from './__generated__/index.graphql';

export const CardPacksGroups = ({
  cardPacksGroups,
  onPackSelect,
}: {
  cardPacksGroups: CardPacksGroups_cardPackGroup[];
  onPackSelect: (cardPackGroupId: string, cardPackSlug: string) => void;
}) => {
  const [matchContainerRefCallback, isWideContainer] = useMatchContainer(
    commonPacksContainerQuery
  );
  return (
    <Vertical gap={3} ref={matchContainerRefCallback}>
      {cardPacksGroups.map(group => (
        <CardPackGroup
          key={group.id}
          cardPackGroup={group}
          onClickBuy={onPackSelect}
          isWideContainer={isWideContainer}
        />
      ))}
    </Vertical>
  );
};

CardPacksGroups.fragments = {
  cardPackGroup: gql`
    fragment CardPacksGroups_cardPackGroup on CardPackGroup {
      id
      ...CardPackGroup_cardPackGroup
    }
    ${CardPackGroup.fragments.cardPackGroup}
  ` as TypedDocumentNode<CardPacksGroups_cardPackGroup>,
};
